// import API from '@/api/masterData/personnel';
import BASE_API from '@/api/dataBase.js';
import { yesNoList } from '@/constants';
export const formColumn = (ctx) => {
  return [
    {
      //立项编号
      prop: 'projectInitiationNo',
      name: '立项编号',
      type: 'input',
      disabled: true,
      isHidden: ctx.isCreate,
    },
    {
      //制单日期
      prop: 'projectInitiationCreateDate',
      name: '制单日期',
      type: 'date',
      disabled: true,
    },
    {
      prop: 'operatorName',
      name: '操作人',
      type: 'input',
      disabled: true,
    },

    {
      prop: 'applyCompanyNo',
      name: '公司',
      type: 'select',
      options: ctx.companyList,
      changeMethod: 'changeMethod',
      disabled:
        ctx.isEdit ||
        ['PIS07', 'PIS08'].includes(ctx.params.projectInitiationStatus) ||
        ctx.formDisabled,
    },
    {
      //申请部门
      prop: 'applyDepartmentNo',
      name: '申请部门',
      type: 'select',
      options: ctx.departmentList || [],
      changeMethod: 'changeMethod',
      clearable: false,
      disabled:
        ctx.isEdit ||
        ['PIS07', 'PIS08'].includes(ctx.params.projectInitiationStatus) ||
        ctx.formDisabled,
    },
    {
      //负责人
      prop: 'chargePersonName',
      name: '负责人',
      type: 'searchTableSpec',
      searchType: 'personnel',
      currentValue: ctx.params.chargePersonName ? ctx.params.chargePersonName : null,
      checkRowKeys: [ctx.params.chargePersonNo ? ctx.params.chargePersonNo : null],
      isMultiple: true,
      changeMethod: 'changeMethod',
      disabled: ctx.formDisabled,
    },
    {
      //业务类型
      prop: 'businessType',
      name: '业务类型',
      type: 'ajaxSelect',
      // clearable: false,
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'PROJECT_INITIATION_BUSINESS_TYPE' },
      changeMethod: 'changeMethod',
      disabled: ctx.formDisabled,
    },
    {
      //项目名称
      prop: 'projectName',
      name: '项目名称',
      type: 'input',
      disabled: ctx.formDisabled,
    },
    {
      //项目简称
      prop: 'projectAbbreviation',
      name: '项目简称',
      type: 'input',
      disabled: ctx.formDisabled,
    },
    {
      //客户名称
      prop: 'customerName',
      name: '客户名称',
      type: 'searchTableSpec',
      isMultiple: true,
      searchType: 'partner',
      extraData: {
        departmentCode: ctx.userInfo.userInfo.departmentCode,
        companyCode: ctx.userInfo.userInfo.companyCode,
      },
      currentValue: ctx.params.customerName ? ctx.params.customerName : null,
      changeMethod: 'changeMethod',
      disabled: ctx.formDisabled,
    },
    {
      //回收公司
      prop: 'recyclingtCompanyName',
      name: '回收公司',
      type: 'select',
      options: ctx.companyList0,
      multiple: true,
      // type: 'searchTableSpec',
      // searchType: 'partner',
      // extraData: {
      //   partnerTypes: 'HZHB02,HZHB03,HZHB09,HZHB11,HZHB13',
      //   departmentCode: ctx.params.applyDepartmentNo,
      //   companyCode: ctx.params.applyCompanyNo,
      // },
      // checkRowKeys: ctx.params.recyclingtCompany,
      // currentValue: ctx.params.recyclingtCompanyName,
      changeMethod: 'changeMethod',
      disabled: ctx.formDisabled,
    },
    {
      //平台公司
      prop: 'platformtCompanyName',
      name: '平台公司',
      type: 'select',
      options: ctx.companyList1,
      multiple: true,
      changeMethod: 'changeMethod',
      disabled: ctx.formDisabled,
    },
    {
      prop: 'projectProvinceCode',
      name: '所属省份',
      type: 'select',
      changeMethod: 'changeMethod',
      options: ctx.dictListMap?.province || [],
      disabled: ctx.formDisabled,
    },
    {
      prop: 'projectCity',
      name: '所属地市',
      type: 'ajaxSelect',
      apiUrl: BASE_API.QUERY_CITY + '?parentAreaNo=' + ctx.params.projectProvinceCode,
      apiData: {},
      changeMethod: 'changeMethod',
      disabled: !ctx.params.projectProvinceCode || ctx.formDisabled,
      valueKey: 'false',
      valueType: 'string',
    },
    {
      //企业属性
      prop: 'enterpriseType',
      name: '企业属性',
      type: 'select',
      // clearable: false,
      options: ctx.dictListMap?.enterprise_type || [],
      changeMethod: 'changeMethod',
      disabled: ctx.formDisabled,
    },
    {
      //项目使用额度
      // prop: 'projectUsageQuota',
      prop: 'projectUsageQuotaWan',
      name: '使用额度',
      type: 'inputNumber',
      append: '万元',
      max: '99999999999.999999',
      placeholder: '万元',
      disabled: ctx.formDisabled,
    },
    {
      //项目应收账款额度
      // prop: 'projectReceivableQuota',
      prop: 'projectReceivableQuotaWan',
      name: '应收账款额度',
      type: 'inputNumber',
      append: '万元',
      max: '99999999999.999999',
      placeholder: '万元',
      disabled: ctx.formDisabled,
    },
    {
      // 下游保证金
      prop: 'downstreamMargin',
      name: '下游保证金',
      type: 'inputNumber',
      max: '99999999999.999999',
      precision: 2,
      placeholder: '请输入',
      append: '万元',
      disabled: ctx.formDisabled,
    },
    {
      // 投送人保证金
      prop: 'depositsInvestors',
      name: '投送人保证金',
      type: 'inputNumber',
      max: '99999999999.999999',
      precision: 2,
      placeholder: '请输入',
      append: '万元',
      disabled: ctx.formDisabled,
    },
    {
      //项目收益点位
      prop: 'projectIncomePoint',
      name: '收益点位',
      type: 'inputNumber',
      max: '99999999999.999999',
      placeholder: '%',
      disabled: ctx.formDisabled,
    },
    {
      //项目账期
      prop: 'projectAccountingPeriod',
      name: '项目账期',
      type: 'inputNumber',
      max: '99999999999',
      placeholder: '天',
      append: '天',
      disabled: ctx.formDisabled,
    },
    {
      //月供货量
      prop: 'monthlySupply',
      name: '月供货量',
      type: 'inputNumber',
      placeholder: '吨',
      max: '99999999999',
      disabled: ctx.formDisabled,
    },
    {
      //营业收入目标
      prop: 'operatingRevenueTarget',
      name: '营收目标',
      type: 'inputNumber',
      placeholder: '万元',
      max: '99999999999.999999',
      disabled: ctx.formDisabled,
    },
    {
      //收货地址
      prop: 'receiptToAddress',
      name: '收货地址',
      type: 'input',
      disabled: ctx.formDisabled,
    },
    {
      //标的物
      prop: 'subjectMatter',
      name: '标的物',
      type: 'select',
      multiple: true,
      options: ctx.dictListMap?.PROJECT_INITIATION_SUBJECT_MATTER || [],
      changeMethod: 'changeMethod',
      disabled: ctx.formDisabled,
    },
    {
      //付款方式
      prop: 'paymentMethod',
      name: '付款方式',
      type: 'ajaxSelect',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'payment_method' },
      changeMethod: 'changeMethod',
      disabled: ctx.formDisabled,
    },
    {
      //回款周期
      prop: 'collectionCycle',
      name: '回款周期',
      placeholder: '天',
      type: 'inputNumber',
      precision: 0,
      disabled: ctx.formDisabled,
    },
    {
      prop: 'apr',
      name: '年化率',
      placeholder: '请输入年化率',
      type: 'inputNumber',
      append: '%',
      precision: 2,
      disabled: ctx.formDisabled,
    },
    {
      prop: 'isAutotrophy',
      name: '是否自营',
      placeholder: '请选择是否自营',
      type: 'select',
      options: yesNoList,
      disabled: ctx.formDisabled,
    },
    {
      prop: 'isPackageDo',
      name: '是否包干',
      placeholder: '请选择是否包干',
      type: 'select',
      options: yesNoList,
      disabled: ctx.formDisabled,
    },
    {
      prop: 'operationManagementCenter',
      name: '运管审批人',
      placeholder: '请输入运管审批人',
      type: 'input',
      disabled: ctx.opreationType ? false : ctx.formDisabled,
    },
    {
      //保供条款
      prop: 'warrantyClause',
      name: '保供条款',
      type: 'textarea',
      span: 24,
      maxlength: 500,
      disabled: ctx.formDisabled,
    },
    {
      //立项变更主要内容
      prop: 'changeContent',
      name: '立项变更主要内容',
      type: 'textarea',
      span: 24,
      maxlength: 1000,
      disabled: ctx.formDisabled,
    },
    {
      //备注
      prop: 'remark',
      name: '备注',
      type: 'textarea',
      span: 24,
      maxlength: 200,
      disabled: ctx.formDisabled,
    },
  ];
};
export const settlementCenterColumn = (ctx) => {
  return [
    {
      //立项编号
      prop: 'projectInitiationNo',
      name: '立项编号',
      type: 'input',
      disabled: true,
      isHidden: ctx.isCreate,
    },
    {
      //制单日期
      prop: 'projectInitiationCreateDate',
      name: '制单日期',
      type: 'date',
      disabled: true,
    },
    {
      prop: 'operatorName',
      name: '操作人',
      type: 'input',
      disabled: true,
    },

    {
      prop: 'applyCompanyNo',
      name: '公司',
      type: 'select',
      options: ctx.companyList,
      changeMethod: 'changeMethod',
      disabled: ctx.isEdit || ['PIS07', 'PIS08'].includes(ctx.params.projectInitiationStatus),
    },
    {
      //申请部门
      prop: 'applyDepartmentNo',
      name: '申请部门',
      type: 'select',
      options: ctx.departmentList || [],
      changeMethod: 'changeMethod',
      clearable: false,
      disabled: ctx.isEdit || ['PIS07', 'PIS08'].includes(ctx.params.projectInitiationStatus),
    },
    {
      //负责人
      prop: 'chargePersonName',
      name: '负责人',
      type: 'searchTableSpec',
      searchType: 'personnel',
      currentValue: ctx.params.chargePersonName ? ctx.params.chargePersonName : null,
      checkRowKeys: [ctx.params.chargePersonNo ? ctx.params.chargePersonNo : null],
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      //业务类型
      prop: 'businessType',
      name: '业务类型',
      type: 'ajaxSelect',
      // clearable: false,
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'PROJECT_INITIATION_BUSINESS_TYPE' },
      changeMethod: 'changeMethod',
    },
    {
      prop: 'partnerZhName',
      name: '结算中心名称',
      type: 'input',
    },
    {
      prop: 'abbreviation',
      name: '结算中心简称',
      type: 'input',
    },
    {
      type: 'input',
      prop: 'creditCode',
      name: '统一社会信用代码',
      changeMethod: 'changeMethod',
    },
    {
      type: 'input',
      prop: 'legalPerson',
      name: '法定代表人',
    },
    {
      prop: 'enterpriseType',
      name: '企业类型',
      type: 'dict',
      dictType: 'enterprise_type',
    },
    {
      name: '成立日期',
      prop: 'establishedDate',
      type: 'date',
      format: 'yyyy-MM-dd',
    },
    {
      type: 'inputNumber',
      prop: 'registeredAssets',
      name: '注册资本',
      max: '99999999999.999999',
      append: '万元',
    },
    {
      type: 'inputNumber',
      prop: 'actualAssets',
      name: '实缴资本',
      max: '99999999999.999999',
      append: '万',
    },
    {
      prop: 'isDomestic',
      name: '国家地区',
      type: 'dict',
      dictType: 'person_national',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'province',
      name: '省份',
      type: 'dict',
      dictType: 'province',
      changeMethod: 'changeMethod',
      isHidden: ctx.showProCity,
    },
    {
      prop: 'city',
      name: '城市',
      type: 'ajaxSelect',
      apiUrl: BASE_API.QUERY_CITY + '?parentAreaNo=' + ctx.params.province,
      apiData: {},
      changeMethod: 'changeMethod',
      disabled: !ctx.params.province,
      isHidden: ctx.showProCity,
    },
    {
      prop: 'invoiceAddress',
      name: '开票地址',
      type: 'input',
    },
    {
      prop: 'invoicePhone',
      name: '开票电话',
      type: 'input',
    },
    {
      prop: 'invoiceBankName',
      name: '开票银行名称',
      type: 'input',
    },
    {
      prop: 'invoiceBankAccount',
      name: '开票银行账户',
      type: 'inputNumber',
    },
    {
      prop: 'isSignGovernmentAgreement',
      name: '是否签订政府协议',
      type: 'select',
      changeMethod: 'changeMethod',
      options: ctx.yesOrNo,
    },
    {
      prop: 'governmentAgreementValidityPeriod',
      name: '政府协议有效期',
      type: 'daterange',
      disabled: ctx.params.isSignGovernmentAgreement != '1',
    },
    {
      prop: 'isPromiseSettlementCost',
      name: '是否对结算成本进行承诺',
      changeMethod: 'changeMethod',
      type: 'select',
      options: ctx.yesOrNo,
    },
    {
      prop: 'unlimitedSettlementCostTerm',
      name: '不限制结算成本期限',
      type: 'select',
      changeMethod: 'changeMethod',
      disabled: ctx.params.isPromiseSettlementCost != '1',
      options: ctx.yesOrNo,
    },
    {
      prop: 'settlementCostTerm',
      name: '结算成本期限',
      type: 'daterange',
      disabled:
        ctx.params.isPromiseSettlementCost != '1' || ctx.params.unlimitedSettlementCostTerm != '0',
    },
    {
      prop: 'isGuarantor',
      name: '是否有担保方',
      type: 'select',
      changeMethod: 'changeMethod',
      options: ctx.yesOrNo,
    },
    {
      prop: 'dateGuarantee',
      name: '担保期限',
      type: 'daterange',
      disabled: ctx.params.isGuarantor != '1',
    },
    {
      prop: 'isNeedTaxCushion',
      name: '是否需要我方垫税',
      type: 'select',
      options: ctx.yesOrNo,
    },
    {
      type: 'inputNumber',
      prop: 'monthlyInvoiceQuantity',
      name: '月发票量',
      max: '99999999999.999999',
      append: '万元',
    },
    {
      prop: 'invoiceFaceValue',
      name: '发票面值',
      type: 'inputNumber',
    },
    {
      prop: 'nowPurchasedInvoice',
      name: '目前已领购发票份数',
      type: 'inputNumber',
    },
    {
      type: 'inputNumber',
      prop: 'availableInvoiceAmount',
      name: '可用发票金额',
      max: '99999999999.999999',
      append: '万元',
    },
    {
      prop: 'settlementCost',
      name: '结算成本',
      type: 'inputNumber',
    },
    {
      prop: 'valueAddedTaxTaxRate',
      name: '增值税税率',
      type: 'inputNumber',
      append: '%',
    },
    {
      //备注
      prop: 'remark',
      name: '备注',
      type: 'textarea',
      span: 24,
      maxlength: 200,
    },
  ];
};
export const downstreamSteelMillColumn = (ctx) => {
  return [
    {
      //立项编号
      prop: 'projectInitiationNo',
      name: '立项编号',
      type: 'input',
      disabled: true,
      isHidden: ctx.isCreate,
    },
    {
      //制单日期
      prop: 'projectInitiationCreateDate',
      name: '制单日期',
      type: 'date',
      disabled: true,
    },
    {
      prop: 'operatorName',
      name: '操作人',
      type: 'input',
      disabled: true,
    },

    {
      prop: 'applyCompanyNo',
      name: '公司',
      type: 'select',
      options: ctx.companyList,
      changeMethod: 'changeMethod',
      disabled: ctx.isEdit || ['PIS07', 'PIS08'].includes(ctx.params.projectInitiationStatus),
    },
    {
      //申请部门
      prop: 'applyDepartmentNo',
      name: '申请部门',
      type: 'select',
      options: ctx.departmentList || [],
      changeMethod: 'changeMethod',
      clearable: false,
      disabled: ctx.isEdit || ['PIS07', 'PIS08'].includes(ctx.params.projectInitiationStatus),
    },
    {
      //负责人
      prop: 'chargePersonName',
      name: '负责人',
      type: 'searchTableSpec',
      searchType: 'personnel',
      currentValue: ctx.params.chargePersonName ? ctx.params.chargePersonName : null,
      checkRowKeys: [ctx.params.chargePersonNo ? ctx.params.chargePersonNo : null],
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      //项目名称
      prop: 'projectName',
      name: '项目名称',
      type: 'input',
    },
    {
      //项目简称
      prop: 'projectAbbreviation',
      name: '项目简称',
      type: 'input',
    },
    {
      //业务类型
      prop: 'businessType',
      name: '业务类型',
      type: 'ajaxSelect',
      // clearable: false,
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'PROJECT_INITIATION_BUSINESS_TYPE' },
      changeMethod: 'changeMethod',
    },
    {
      prop: 'invoiceAddress',
      name: '合作伙伴名称',
      type: 'input',
    },
    {
      prop: 'projectProvinceCode',
      name: '所属省份',
      type: 'select',
      changeMethod: 'changeMethod',
      options: ctx.dictListMap?.province || [],
    },
    {
      prop: 'projectCity',
      name: '所属地市',
      type: 'ajaxSelect',
      apiUrl: BASE_API.QUERY_CITY + '?parentAreaNo=' + ctx.params.projectProvinceCode,
      apiData: {},
      changeMethod: 'changeMethod',
      disabled: !ctx.params.projectProvinceCode,
      valueKey: 'false',
      valueType: 'string',
    },
    {
      //资金额度
      prop: 'projectUsageQuota',
      name: '资金额度',
      type: 'inputNumber',
      max: '99999999999.999999',
    },
    {
      //收入目标
      prop: 'operatingRevenueTarget',
      name: '收入目标',
      type: 'inputNumber',
      placeholder: '万元',
      max: '99999999999.999999',
    },
    {
      //利润目标
      prop: 'operatingRevenueTarget',
      name: '利润目标',
      type: 'inputNumber',
      placeholder: '元',
      max: '99999999999.999999',
    },
    {
      //回款周期
      prop: 'collectionCycle',
      name: '回款周期',
      placeholder: '天',
      type: 'inputNumber',
      precision: 0,
    },
    {
      prop: 'apr',
      name: '资金收益率',
      placeholder: '请输入资金收益率',
      type: 'inputNumber',
      append: '%',
      precision: 2,
    },
    {
      prop: 'invoiceAddress',
      name: '开票地址',
      type: 'input',
    },
    {
      prop: 'invoicePhone',
      name: '开票电话',
      type: 'input',
    },
    {
      prop: 'invoiceBankName',
      name: '开票银行名称',
      type: 'input',
    },
    {
      prop: 'invoiceBankAccount',
      name: '开票银行账户',
      type: 'inputNumber',
    },
    {
      prop: 'changeContent',
      name: '业务链',
      type: 'textarea',
      span: 24,
      maxlength: 600,
    },
    {
      //备注
      prop: 'remark',
      name: '备注',
      type: 'textarea',
      span: 24,
      maxlength: 200,
    },
  ];
};
export const formRules = (ctx) => {
  return {
    settlementCostTerm: [
      {
        required:
          ctx.params.isPromiseSettlementCost == '1' &&
          ctx.params.unlimitedSettlementCostTerm == '0',
        message: '结算成本期限不能为空',
        trigger: 'change',
      },
    ],
    dateGuarantee: [
      {
        required: ctx.params.isGuarantor == '1',
        message: '担保期限不能为空',
        trigger: 'change',
      },
    ],
    governmentAgreementValidityPeriod: [
      {
        required: ctx.params.isSignGovernmentAgreement == '1',
        message: '政府协议有效期不能为空',
        trigger: 'change',
      },
    ],
    settlementCost: [
      {
        required: true,
        message: '结算成本不能为空',
        trigger: 'change',
      },
    ],
    valueAddedTaxTaxRate: [
      {
        required: true,
        message: '增值税税率不能为空',
        trigger: 'change',
      },
    ],
    nowPurchasedInvoice: [
      {
        required: true,
        message: '目前已领购发票份数不能为空',
        trigger: 'change',
      },
    ],
    availableInvoiceAmount: [
      {
        required: true,
        message: '可用发票金额不能为空',
        trigger: 'change',
      },
    ],
    invoiceFaceValue: [
      {
        required: true,
        message: '发票面值不能为空',
        trigger: 'change',
      },
    ],
    monthlyInvoiceQuantity: [
      {
        required: true,
        message: '月发票量不能为空',
        trigger: 'change',
      },
    ],
    // ======
    downstreamMargin: [
      {
        required: true,
        message: '下游保证金不能为空',
        trigger: 'change',
      },
    ],
    depositsInvestors: [
      {
        required: true,
        message: '投送人保证金不能为空',
        trigger: 'change',
      },
    ],
    applyDepartmentNo: [
      {
        required: true,
        message: '申请部门不能为空',
        trigger: 'change',
      },
    ],
    applyCompanyNo: [
      {
        required: true,
        message: '公司不能为空',
        trigger: 'change',
      },
    ],
    chargePersonName: [
      {
        required: true,
        message: '负责人不能为空',
        trigger: 'change',
      },
    ],
    projectName: [
      {
        required: true,
        message: '项目名称不能为空',
        trigger: 'change',
      },
    ],
    projectAbbreviation: [
      {
        required: true,
        message: '项目简称不能为空',
        trigger: ['change', 'blur'],
      },
    ],
    businessType: [
      {
        required: true,
        message: '业务类型不能为空',
        trigger: 'change',
      },
    ],
    customerName: [
      {
        required: true,
        message: '客户名称不能为空',
        trigger: 'change',
      },
    ],
    projectProvinceCode: [
      {
        required: true,
        message: '项目所属省份不能为空',
        trigger: 'change',
      },
    ],
    projectCitys: [
      {
        required: true,
        message: '项目所属地市不能为空',
        trigger: 'change',
      },
    ],
    recyclingtCompanyName: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    platformtCompanyName: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    isPackageDo: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    isAutotrophy: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    enterpriseType: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    projectUsageQuota: [
      {
        required: true,
        message: '项目使用额度不能为空',
        trigger: 'change',
      },
    ],
    projectReceivableQuota: [
      {
        required: true,
        message: '项目应收账款额度不能为空',
        trigger: 'change',
      },
    ],
    projectIncomePoint: [
      {
        required: true,
        message: '项目收益点位不能为空',
        trigger: 'change',
      },
    ],
    projectAccountingPeriod: [
      {
        required: true,
        message: '项目账期不能为空',
        trigger: 'change',
      },
    ],
    monthlySupply: [
      {
        required: true,
        message: '月供货量不能为空',
        trigger: 'change',
      },
    ],
    operatingRevenueTarget: [
      {
        required: true,
        message: '营业收入目标不能为空',
        trigger: 'change',
      },
    ],
    paymentMethod: [
      {
        required: true,
        message: '付款方式不能为空',
        trigger: 'change',
      },
    ],
    collectionCycle: [
      {
        required: true,
        message: '回款周期不能为空',
        trigger: 'change',
      },
    ],
    partnerZhName: [
      {
        required: true,
        message: '结算中心名称不能为空',
        trigger: 'change',
      },
    ],
    abbreviation: [
      {
        required: true,
        message: '结算中心简称不能为空',
        trigger: 'change',
      },
    ],
    creditCode: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
      { min: 18, max: 18, message: '长度18个字符', trigger: ['blur', 'change'] },
    ],
    legalPerson: [
      {
        required: true,
        message: '法定代表人不能为空',
        trigger: 'change',
      },
    ],
    // enterpriseType: [
    //   {
    //     required: true,
    //     message: '企业类型不能为空',
    //     trigger: 'change',
    //   },
    // ],
    establishedDate: [
      {
        required: true,
        message: '成立日期不能为空',
        trigger: 'change',
      },
    ],
    registeredAssets: [
      {
        required: true,
        message: '注册资本不能为空',
        trigger: 'change',
      },
    ],
    isDomestic: [
      {
        required: true,
        message: '国家地区不能为空',
        trigger: 'change',
      },
    ],
    province: [
      {
        required: true,
        message: '省份不能为空',
        trigger: 'change',
      },
    ],
    city: [
      {
        required: true,
        message: '城市不能为空',
        trigger: 'change',
      },
    ],
    invoiceAddress: [
      {
        required: true,
        message: '开票地址不能为空',
        trigger: 'change',
      },
    ],
    invoicePhone: [
      {
        required: true,
        message: '开票电话不能为空',
        trigger: 'change',
      },
    ],
    invoiceBankName: [
      {
        required: true,
        message: '开票银行名称不能为空',
        trigger: 'change',
      },
    ],
    invoiceBankAccount: [
      {
        required: true,
        message: '开票银行账号不能为空',
        trigger: 'change',
      },
    ],
    isSignGovernmentAgreement: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    isPromiseSettlementCost: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    isGuarantor: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    isNeedTaxCushion: [
      {
        required: true,
        message: '必填字段',
        trigger: 'change',
      },
    ],
  };
};
